<template>
    <div class="full-width flex align-center justify-between">
        <template v-for="(e, i) in props.totalData" :key="i">
            <!-- <p class="flex align-center"> --> 
                <StNormal :is-top="false" :one="e" />
            <!-- </p> -->
        </template>
    </div>
</template>

<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';
import Comm from '@/components/common.js';

import StNormal from '@/views/userMapMain/components/StNormal.vue';
const props = defineProps({
    isTop: {
        Type: Boolean,
        required: true,
    },
    totalData: {
        Type: Object,
        required: true,
    },
    // one: {
    //     Type: Object,
    //     required: true,
    // },
});

const type = computed(() => {
    return props?.one?.learningType ? Comm.getNoOfStudyType(true, props.one.learningType) : '';
});
const typeName = computed(() => {
    return Comm.getTypeNameOfStudyType(type.value);
});

const classForType = computed(() => {
    return Comm.getClassOfStudyType(type.value);
});

// const kind = computed(() => props.kind);

onMounted(() => {});
</script>

<style scoped lang="scss"></style>
